export default "__VITE_ASSET__71528383__"